<template>
  <component :is="way" v-if="way" v-bind="{ ...$attrs, ...$props }" v-on="$listeners" />
</template>

<script>
  import { mapGetters } from 'vuex';
  import PROCESS_NAMES from '@/process/names';
  const Sportmaster = () => import('@/process/sportmaster/components/response/tabs/TabDuplicates');

  export default {
    components: {
      Sportmaster
    },

    computed: {
      ...mapGetters('process', ['getProcessName']),

      way() {
        if (this.getProcessName !== undefined) {
          if (this.getProcessName === PROCESS_NAMES.SPORTMASTER) {
            return this.getProcessName;
          }
        }

        return false;
      }
    }
  };
</script>
